@if (slide) {
  <div class="onboarding-slide-content">
    <div class="slide-body">
      <h1>{{ header | translate }}</h1>
      <p [innerHTML]="body | translate"></p>
    </div>
    @if (asset) {
      <div class="slide-image">
        <img [appSrcset]="asset | translate" alt="" pxWidth="600" />
      </div>
    }
  </div>
}
